import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'

import type { DialogProps } from '../types'

interface Props extends DialogProps {
  onSave: () => void
  onReset: () => void
}

export const UnsavedSalesTemplateDialog = ({
  isOpen,
  onClose,
  onSave,
  onReset,
}: Props) => {
  const handleClickNo = () => {
    onReset()
    onClose()
  }

  const handleClickYes = () => {
    onSave()
    onClose()
  }

  return (
    <Dialog
      bigDialog
      show={isOpen}
      onClose={onClose}
      childrenClassName="space-y-6"
      panelClassName="lg:max-w-[560px]"
    >
      <Dialog.Header>
        <Dialog.Title>Unsaved changes</Dialog.Title>
        <Dialog.Description className="mx-auto block max-w-[407px] text-center">
          Save dashboard changes as a new template before applying the selected
          template?
        </Dialog.Description>
      </Dialog.Header>
      <Dialog.ClosableFooter
        onClose={onClose}
        className="grid-cols-3"
      >
        <Button
          variant="outline"
          onClick={handleClickNo}
        >
          No
        </Button>
        <Button onClick={handleClickYes}>Yes</Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
